<p class="opacity-60 mt-3 w-full text-center"><a href="/">OrlaEganCork.com</a>, Copyright 2022, All rights reserved. Website Created by <a href="https://jacob-lily.net" target="_blank">Jacob-Lily.net</a></p>

<style>
    a { text-decoration: dotted underline; }
</style>